<template>
  <input-select ref="select" v-model="value" caption="Выберите ТС..." :itemList="items"></input-select>
</template>

<script>
export default {
  props: ['model-value'],
  emits: ['update:model-value'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:model-value', value)
      }
    },
    items() {
      return this.$store.getters['getTS'].map(item => {
        return {
          id: item.ts_id,
          title: item.ts_garagnum,
        }
      });
    }
  },
  methods: {
    validate() {
      return this.$refs.select.validate()
    }
  }
}
</script>
